import { get } from "api/axios";
import endPoints from "api/endPoints";
import React, { useEffect, useState } from "react";
import parse from "html-react-parser";
export default function Terms() {
  const [termCondition, setTermCondition] = useState();
  const fetchHandler = async () => {
    try {
      const resp = await get(`${endPoints.terms}?filter=term`);
      if (resp?.data?.success) {
        setTermCondition(resp?.data?.data);
      }
    } catch (err) {
      console.error("I am From Term Pages", err);
    }
  };

  useEffect(() => {
    fetchHandler();
  }, []);

  return (
    <div className="container py-5">
      <div className="about-elevated-content text-md-start text-center pb-3">
        <h2 className="fs-80 hc fw-700 l-h-0-9 ">Terms &</h2>

        <p className="fs-64 l-h-0-9 custom-color-blue fw-300">Condition</p>
      </div>
      <div>
        <p className="text-white my-md-4 my-2 fw-300 l-h-1-3 fs-18 termStyle">
          {parse(termCondition?.at(0).content.htmlContent || "")}
        </p>
      </div>
    </div>
  );
}
